import {FullscreenLayer, styled} from '@volkswagen-onehub/components-core';
import {Close} from '@volkswagen-onehub/icons-core';
import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import GradientMeshBackground from '../components/GradientMeshBackground';
import IntroStep from './intro-step';
import WalkthroughSwiper from './swiper/walkthrough-swiper';
import {Container} from './common-components';
import {getHeader} from '../helpers/get-header';
import ChooseSwiper from './swiper/choose-swiper';
import FinalStep from './final-step';
import useMediaQuery from '../hooks/useMediaQuery';
import MobileOnlyScreen from './mobile-only-screen';

const CloseButton = styled.button`
  all: unset;
  position: fixed;
  top: 8px;
  right: 8px;
  color: #fff;
  cursor: pointer;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 10px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.5;
  }

  & > svg {
    width: 16px;
    height: 16px;
  }
`;

export enum Steps {
  INTRO = 1,
  WALKTHROUGH = 2,
  CHOOSE = 3,
  FINAL = 4,
}

type Props = {
  isCustomers?: boolean;
};

const AppScreen: React.FC<Props> = ({isCustomers}) => {
  const [step, setStep] = React.useState<Steps>(Steps.INTRO);
  const history = useHistory();
  const location = useLocation();
  const {isMobile} = useMediaQuery();

  const onClose = () => {
    //add nav header to DOM
    const header = getHeader();
    if (header) {
      header.classList.remove('ev-hub-hidden');
    }

    if (location.key) {
      history.goBack();
    } else {
      window.location.href = 'https://www.volkswagen.com.au/en.html';
    }
  };

  useEffect(() => {
    //remove nav header from DOM
    const header = getHeader();
    if (header) {
      header.classList.add('ev-hub-hidden');
    }
  }, []);

  return (
    <div
      style={{zIndex: 9999, position: 'fixed', width: '100%', height: '100vh'}}
    >
      <FullscreenLayer active>
        <CloseButton onClick={onClose}>
          <Close />
        </CloseButton>
        {isMobile ? (
          <Container>
            {step === Steps.INTRO && (
              <IntroStep setStep={setStep} isCustomers={isCustomers} />
            )}
            {step === Steps.WALKTHROUGH && (
              <WalkthroughSwiper setStep={setStep} isCustomers={isCustomers} />
            )}
            {step === Steps.CHOOSE && <ChooseSwiper setStep={setStep} />}
            {step === Steps.FINAL && (
              <FinalStep setStep={setStep} isCustomers={isCustomers} />
            )}
          </Container>
        ) : (
          <MobileOnlyScreen />
        )}

        <GradientMeshBackground />
      </FullscreenLayer>
    </div>
  );
};

export default AppScreen;
